import React, { useEffect, Fragment, useState } from 'react'

import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import TabsComponent from '../preparar-carta-cobro/TabsComponent'

import {  useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import { Auth, LoadingComponent } from 'recupero-comunes'

import FormularioPrincipal from './fomularioPrincipal'
import { CasoGeneralComponent } from 'reccol-caso-general';
const ProcesarRespuestaCobro = () => {
 
  const {state}=useLocation()
  const { rutUsuario, rutOrganizacion } = Auth.currentUser()
  // El hook useSelector (redux) permite acceder al state en nuestro store.
  
  const dispatch = useDispatch();
  const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :60
  const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
  const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
 
 
 
  
  return (
    <>
   
     <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                                         {`Aprobación u Objeción de Cobro CIAS - Caso ${idCasoLocation}`}</Card.Header>
                <Card.Body>
            <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} /> 
            </Card.Body>
            </Card>
    
           <FormularioPrincipal/>
            </Container>
        
    
    </>
  )
}
export default ProcesarRespuestaCobro
